const message = {
  "button.home.sendFiles": "Envoyer des fichiers",

  "button.options.record": "Enregistrer maintenant",
  "button.options.upload": "Envoyer des fichiers",
  "button.options.gallery": "Voir l'album",
  "button.options.bingoGame": "Bingo",
  "button.options.photoChallengeGame": "Défi photo",
  "button.options.quizGame": "Quiz",
  "button.options.teamMatchGame": "Match d'équipe",
  "button.options.foodMenu": "Menu",
  "button.options.schedule": "Horaire",
  "button.options.feed": "Fil de la fête",
  "message.options.bingoGame": "Jouez au bingo de la fête !",
  "message.options.photoChallengeGame": "Participez au défi photo !",
  "message.options.quizGame": "Testez vos connaissances !",
  "message.options.teamMatchGame": "De quelle équipe faites-vous partie ?",
  "message.options.foodMenu": "Consultez le menu de la fête !",
  "message.options.schedule": "Consultez l'horaire de l'événement !",
  "message.options.record": "Enregistrez votre message spécial maintenant !",
  "message.options.upload":
    "Partagez les meilleures photos et vidéos de la fête !",
  "message.options.gallery": "Regardez les photos de l'événement !",
  "message.options.feed": "Suivez la chronologie de l'événement!",

  "title.terms": "Conditions d'utilisation",
  "title.notFound": "Oups, il semble que cette page n'existe pas.",
  "title.eventNotFound": "Erreur lors de l'accès à l'événement",

  "subtitle.goBackTo": "Retour à la",
  "subtitle.eventNotFound": "Événement non trouvé ou expiré.",

  "message.termsOfUse":
    "En utilisant notre système, vous acceptez nos <code>Conditions d'utilisation</code>",
  "message.termsFirstParagraph":
    "En utilisant notre système de téléchargement de photos et de vidéos, vous acceptez, en tant qu'invité de l'événement, que nous collections et téléchargeons vos données, y compris des photos, des vidéos et des informations personnelles, et que nous les mettions à la disposition de l'organisateur de l'événement.",
  "message.termsSecondParagraph":
    "Nous n'accédons pas à vos fichiers sauf si le client le demande pour fournir une assistance technique, limitée à ce qui est nécessaire.",
  "message.termsThirdParagraph":
    "La société ne partage pas de données avec des tiers et maintient la confidentialité des informations, sauf lorsque la loi l'exige.",
  "message.shareLink":
    "Pour maintenir la qualité du fichier, téléchargez des fichiers depuis la galerie de votre appareil.",

  // recorder
  "button.recorder.home": "Retour à l'écran initial",
  "button.recorder.understood": "Compris !",
  "button.recorder.close": "Fermer",
  "button.recorder.share": "Partager",
  "button.recorder.back": "Retour",

  "title.recorder.permissionsToRecordAudioVideo": "Permission d'enregistrer",
  "title.recorder.success": "Succès !",
  "title.recorder.uploading": "Envoi en cours",
  "title.recorder.alert": "Alerte !",
  "title.recorder.saving": "Enregistrement",
  "title.recorder.waiting": "En attente",
  "title.recorder.share": "Partagez !",
  "title.recorder.error": "Erreur !",
  "title.recorder.permissionCameraOrMicrophoneDenied":
    "Permission non accordée",
  "title.recorder.terms": "Conditions d'utilisation",

  "subtitle.recorder.nextScreenClickAllow":
    "Sur l'écran suivant, cliquez sur <code>Autoriser</code>.",
  "subtitle.recorder.allowReinforcement":
    "Vous devez cliquer sur <code>Autoriser</code> pour enregistrer votre message.",
  "subtitle.recorder.share": "Invitez vos amis à enregistrer aussi !",
  "subtitle.recorder.dontRefreshPage":
    "Veuillez ne pas actualiser ou fermer cette page.",
  "subtitle.recorder.status.success":
    "Votre message a été enregistré avec succès !",
  "subtitle.recorder.browserNotSupported":
    "Votre navigateur n'est pas pris en charge ou la permission n'a pas été accordée.",
  "subtitle.recorder.tryGrantPermission":
    "1. Actualisez la page et autorisez l'utilisation de la caméra.",
  "subtitle.recorder.tryAnotherBrowser":
    "2. Essayez d'utiliser un autre navigateur comme {chrome} ou {safari}.",
  "subtitle.recorder.mustLongerThan":
    "Le message doit durer plus de <code>5 secondes</code>.",
  "subtitle.recorder.offline":
    "Vous êtes hors ligne. Veuillez vérifier votre connexion.",
  "subtitle.recorder.startRecord": "Cliquez pour commencer à enregistrer.",
  "subtitle.recorder.recording": "Enregistrement...",
  "subtitle.recorder.uploadError": "Erreur lors du téléchargement de la vidéo.",
  "subtitle.recorder.tryAgain": "Vérifiez votre connexion et réessayez.",
  "subtitle.recorder.permissionCameraOrMicrophoneDenied":
    "L'utilisation de la caméra/du microphone n'a pas été autorisée.",
  "subtitle.recorder.trySafariBrowser":
    "1. Utilisez le navigateur <code>SAFARI</code>.",
  "subtitle.recorder.changeSiteSettingsUsingSafari":
    '2. Cliquez sur le bouton <code>"aA"</code> dans la barre d\'URL et sur <code>"Paramètres du site"</code>',
  "subtitle.recorder.grantCameraAndMicrophonePermissions":
    "3. <code>Autorisez l'utilisation</code> de la caméra et du microphone",
  "subtitle.recorder.refreshPage": "4. Actualisez la page",
  "subtitle.recorder.tryChromeBrowser":
    "1. Utilisez le navigateur <code>CHROME</code>",
  "subtitle.recorder.changeSiteSettingsUsingChrome":
    '2. Accédez aux paramètres du site et cliquez sur <code>"Permissions"</code>',

  "message.recorder.almostDone":
    "Presque fini ! Juste quelques secondes de plus.",
  "message.recorder.sendingMessage":
    "Nous envoyons maintenant votre message. Cela peut prendre un peu de temps car il est plein de choses formidables.",

  "title.recorder.upload": "Téléversement",

  "subtitle.recorder.filesReadyToUpload": "Fichier prêt à être téléversé :",

  "subtitle.recorder.fileWithError": "Fichier qui ne sera pas téléversé :",

  "message.recorder.fileSizeError": "Le fichier dépasse la taille autorisée",

  "button.recorder.send": "Envoyer",

  "message.recorder.uploading":
    "Veuillez ne pas actualiser ou fermer cette page.",

  "message.recorder.uploadError": "Échec du téléversement.",

  "title.recorder.uploadFailure": "Échec du téléversement",

  "title.recorder.completed": "Terminé",

  "message.recorder.uploadComplete": "Téléversement terminé",

  "message.recorder.fileUploaded": "Fichier téléversé avec succès",

  "message.recorder.uploadFailed": "Échec du téléversement du fichier",

  "message.recorder.checkYourConnectionAndTryAgain":
    "Veuillez vérifier votre connexion et réessayer",

  "button.recorder.ok": "OK !",

  "title.recorder.shareMoments": "Envoyez votre message",

  "subtitle.recorder.forThe1YearAnniversary": "Pour le 1er anniversaire",

  "subtitle.recorder.now": "Pour Maintenant",

  "message.recorder.uploadMaxFilesLimit":
    "Téléversez <code>1 vidéo</code> à la fois.",

  "message.recorder.uploadLimit": "Limite maximale :",

  "message.recorder.videoSizeLimit": "<code>800 Mo</code> par vidéo.",

  "button.recorder.send_video": "Envoyer la vidéo",

  "message.recorder.uploadTip":
    "Cliquez sur le bouton ci-dessus et sélectionnez la vidéo que vous venez d’enregistrer !",

  "title.recorder.guide.instructionsToRecord": "Instructions d’enregistrement",

  "subtitle.recorder.guide.instructions":
    "Ouvrez la <code>caméra</code> de votre appareil en mode selfie et enregistrez votre message d’une durée maximale de <code>2 minutes</code> !",

  "subtitle.recorder.guide.moreInstructions":
    "Revenez ensuite ici pour envoyer votre message !",

  "message.recorder.instructions":
    "<code>Ouvre l’application appareil photo</code> de ton appareil en mode selfie et enregistre ton message de <code>2 minutes</code> max !",
  "button.recorder.sendVideo": "Envoyer la vidéo",
  "message.recorder.uploadTip.ios":
    "💡 Pour une meilleure qualité, choisis une vidéo depuis ta galerie",

  // uploader
  "button.uploader.send_photos": "Envoyer photos",
  "button.uploader.send_video": "Envoyer vidéo",
  "button.uploader.close": "Fermer",
  "button.uploader.share": "Partager",
  "button.uploader.back": "Retour",
  "button.uploader.send": "Envoyer",
  "button.uploader.continue": "Continuer",
  "button.uploader.ok": "OK!",

  "title.uploader.success": "Succès!",
  "title.uploader.uploading": "Téléchargement",
  "title.uploader.alert": "Alerte!",
  "title.uploader.saving": "Sauvegarde",
  "title.uploader.waiting": "En attente",
  "title.uploader.share": "Partager!",
  "title.uploader.error": "Erreur!",
  "title.uploader.upload": "Télécharger",
  "title.uploader.shareMoments": "Partagez des moments",
  "title.uploader.uploadFailure": "Échec du téléchargement",
  "title.uploader.completed": "Terminé",
  "title.uploader.terms": "Conditions d'utilisation",

  "subtitle.uploader.filesWithError":
    "Fichiers qui <code>ne seront pas envoyés</code> :",
  "subtitle.uploader.uploadHistory": "Téléchargements terminés",
  "subtitle.uploader.filesReadyToUpload": "Fichiers prêts à être téléchargés :",

  "message.uploader.uploadMaxFilesLimit":
    "Envoyez jusqu'à <code>50 photos ou 1 vidéo</code> à la fois.",
  "message.uploader.uploadLimit": "Limite maximale :",
  "message.uploader.photoSizeLimit": "<code>20Mo</code> par photo",
  "message.uploader.videoSizeLimit": "<code>200Mo</code> par vidéo",
  "message.uploader.fileSizeError": "Le fichier dépasse la taille autorisée.",
  "message.uploader.uploading":
    "Veuillez ne pas actualiser ou fermer cette page.",
  "message.uploader.uploadError": "Échec du téléchargement.",
  "message.uploader.maxFilesLimitError":
    "Sélectionnez au <code>maximum 50 photos</code>.",
  "message.uploader.notFoundFilesToUpload":
    "<code>Aucun fichier ne peut être envoyé</code>.",
  "message.uploader.checkFileSizeAndTryAgain":
    "Veuillez vérifier la <code>taille du fichier</code> et réessayer.",
  "message.uploader.uploadComplete": "Téléchargement terminé",
  "message.uploader.allFilesUploaded": "Tous les fichiers ont été envoyés",
  "message.uploader.nFilesUploaded": "{n} fichiers envoyés",
  "message.uploader.nFilesNotUploaded": "{n} fichier(s) non envoyé(s)",
  "message.uploader.noFilesUploaded": "Aucun fichier n'a été envoyé",
  "message.uploader.checkYourConnectionAndTryAgain":
    "Vérifiez votre connexion et réessayez.",
  "message.uploader.uploadVerySlow":
    "Si le téléchargement est lent, sélectionnez quelques photos à la fois",
  "message.uploader.uploadTip":
    "Pour maintenir la qualité du fichier, téléchargez des fichiers depuis la galerie de votre appareil.",

  "title.guestForm": "Votre Profil",
  "placeholder.guestForm.name": "Votre nom ou surnom",
  "message.guestForm.dataInfo":
    "Les données fournies ne sont pas obligatoires. Elles seront affichées uniquement comme une signature sur les photos et vidéos que vous envoyez.",
  "button.guestForm.takePhoto": "Prenez un selfie (optionnel)",
  "button.guestForm.submit": "Enregistrer",
  "button.guestForm.uploading": "Enregistrement...",
  "button.guestForm.skip": "Continuer de manière anonyme",
  "message.guestForm.nameRequired": "Le nom est obligatoire",
  "message.cameraNotAvailable":
    "Impossible d'accéder à la caméra. Veuillez vous assurer que vous avez accordé les autorisations pour la caméra.",
  "title.guestForm.cropPhoto": "Recadrer la photo",
  "button.guestForm.selectPhoto": "Sélectionner une photo (facultatif)",

  "title.photoChallenge": "Défi Photo",
  "subtitle.photoChallenge.tasks": "Tâches",
  "subtitle.photoChallenge.done": "Terminées",
  "message.photoChallenge.intro":
    "L'objectif est de prendre des photos comme indiqué dans chaque objectif.",
  "message.photoChallenge.todo": "Relevez un défi",
  "message.photoChallenge.done": "Défis terminés",
  "button.photoChallenge.start": "Commencer",

  "title.quiz": "Quiz",
  "subtitle.quiz.intro": "Acceptez-vous le défi?",
  "subtitle.quiz.result": "Résultat",
  "message.quiz.intro":
    "Parmi tous les invités, prouvez que vous êtes la personne qui connaît le mieux le couple!",
  "button.quiz.start": "Commencer",
  "button.quiz.confirm": "Confirmer",
  "message.quiz.result":
    "Vous avez obtenu {score} sur {totalQuestions} questions en {time} secondes",
  "message.quiz.saving": "Sauvegarde...",
  "button.quiz.share": "Partager le résultat",
  "message.quiz.congrats": "🎉 Félicitations ! 🎉",

  "message.bingo.intro":
    "Pouvez-vous compléter le bingo tout en vous amusant avec chaque défi ?",
  "button.bingo.start": "Commencer",
  "label.bingo.fullCard": "Carte complète",
  "label.bingo.line": "Ligne",
  "label.bingo.firstColumn": "1ère - Colonne",
  "label.bingo.firstRow": "1ère - Ligne",
  "subtitle.bingo.results": "Résultats",
  "message.bingo.selectChallenge": "Cliquez pour voir et compléter le défi",
  "button.bingo.removeChallenge": "Retirer le défi",
  "button.bingo.continue": "Continuer",
  "message.bingo.progress": "Continuez à compléter les défis du bingo !",
  "button.bingo.share": "Partager",

  "message.photoChallenge.intro.new":
    "C'est facile : suivez les instructions et amusez-vous à prendre des photos !",
  "message.photoChallenge.inProgress.new":
    "Sélectionnez un défi ci-dessous et envoyez votre photo.",
  "button.photoChallenge.share": "Partager le résultat",
  "message.photoChallenge.completed":
    "Vous avez complété tous les {total} défis photo !",
  "message.photoChallenge.congrats": "🎉 Félicitations ! 🎉",

  "title.teamMatch": "Match d'Équipe",
  "subtitle.teamMatch.intro": "Découvrez votre équipe",
  "subtitle.teamMatch.result": "Résultat",
  "message.teamMatch.intro":
    "Faites le test et découvrez si vous faites partie de l'équipe {teamA} ou de l'équipe {teamB} !",
  "button.teamMatch.start": "Commencer",
  "button.teamMatch.next": "Suivant",
  "message.teamMatch.result": "Votre équipe est <code>{team}</code> !",
  "message.teamMatch.saving": "Enregistrement...",
  "button.teamMatch.share": "Partager le résultat",

  "feed.loading": "Chargement du flux...",
  "feed.empty": "Aucun élément dans le flux pour le moment.",
  "feed.imageAlt": "Image Téléchargée",
  "feed.anonymousGuest": "Invité anonyme",
  "feed.imageUploader.title": "Photo Téléchargée",

  "feed.quiz.title": "Quiz",
  "feed.quiz.description":
    "{guestName} a complété le quiz ! Résultat : {score}/{total} en {time} secondes",
  "feed.photoChallenge.title": "Défi Photo",
  "feed.photoChallenge.description":
    "{guestName} a complété le défi : {challenge}",
  "feed.teamMatch.title": "Match d'Équipe",
  "feed.teamMatch.description":
    "{guestName} a participé au Match d'Équipe. Résultat : {teamAName} {scoreA} x {scoreB} {teamBName}",
  "feed.newGuest.title": "Nouvel Invité",
  "feed.newGuest.description": "{guestName} a rejoint l'événement",
  "feed.videoRecorder.title": "Nouveau Message",
  "feed.videoRecorder.description": "{guestName} a envoyé un nouveau message",
  "feed.default.title": "Activité",
  "feed.default.description": "Une nouvelle activité s'est produite",

  "feed.ctaPost.ctaButton":
    "Vous aimez l’événement ? Publiez aussi une photo !",
  "feed.imageUploader.description":
    "{guestName} a téléchargé des fichiers dans la galerie de la fête",
  "feed.cdt-imageUploader.title": "Nouveau message",
  "feed.cdt-imageUploader.description":
    "{guestName} a téléchargé des fichiers pour l’anniversaire de 1 an !",
  "feed.quiz.ctaButton": "Testez vos connaissances",
  "feed.photoChallenge.ctaButton": "Relevez aussi un défi",
  "feed.teamMatch.ctaButton": "Participez au Team Match",
  "feed.videoRecorder.ctaButton": "Enregistrez un message maintenant",
  "feed.videoUploader.title": "Nouveau message",
  "feed.videoUploader.description":
    "{guestName} a téléchargé une vidéo dans la galerie de la fête",
  "feed.cdt-videoUploader.title": "Nouveau message",
  "feed.cdt-videoUploader.description":
    "{guestName} a téléchargé une vidéo pour l’anniversaire de 1 an !",
  "feed.newPost.title": "Nouvelle publication",
  "feed.cdtVideoRecorder.description":
    "<code>{guestName}</code> a déjà laissé un message pour le <code>1er anniversaire !</code>",
  "feed.cdtVideoRecorder.ctaButton": "Faites de même !",
  "feed.placeholder.newPost": "Créer une publication...",
  "feed.placeholder.newPostMessage": "Écrivez votre message...",

  "feed.menu.title.interaction": "Envoyer des fichiers",
  "feed.menu.button.options.newPost": "Créer une publication",
  "feed.menu.message.options.newPost": "Créez une publication dès maintenant !",
  "feed.menu.button.options.record": "Enregistrer maintenant",
  "feed.menu.message.options.record":
    "Enregistrez votre message spécial maintenant !",
  "feed.menu.button.options.upload": "Choisir des fichiers",
  "feed.menu.message.options.upload":
    "Partagez les meilleures photos et vidéos de la fête !",
  "feed.menu.title.gallery": "Galerie de la fête",
  "feed.menu.button.options.gallery": "Voir l’album",
  "feed.menu.message.options.gallery": "Découvrez les photos de l’événement !",
  "feed.menu.title.games": "Jeux",
  "feed.menu.button.options.bingoGame": "Bingo",
  "feed.menu.message.options.bingoGame": "Jouez au bingo de la fête !",
  "feed.menu.button.options.photoChallengeGame": "Défi photo",
  "feed.menu.message.options.photoChallengeGame": "Participez au défi photo !",
  "feed.menu.button.options.quizGame": "Quiz",
  "feed.menu.message.options.quizGame": "Testez vos connaissances !",
  "feed.menu.button.options.teamMatchGame": "Team Match",
  "feed.menu.message.options.teamMatchGame":
    "De quelle équipe faites-vous partie ?",
  "feed.menu.title.info": "À propos de l’événement",
  "feed.menu.button.options.foodMenu": "Menu",
  "feed.menu.message.options.foodMenu": "Découvrez le menu de la fête !",
  "feed.menu.button.options.schedule": "Programme",
  "feed.menu.message.options.schedule": "Consultez le programme de la fête !",
  "feed.menu.title.guestInfo": "Vos informations",
  "feed.menu.options.anonymousGuest": "Invité anonyme",
  "feed.menu.options.guestEditInfo": "Cliquez pour modifier vos informations !",
  "feed.menu.title.other": "Autres",
  "feed.menu.button.options.language": "Langue",
  "feed.menu.message.options.languageInfo": "Cliquez pour changer la langue !",
  "feed.button.options.cancel": "Annuler",
  "feed.button.options.confirm": "Confirmer",
  "feed.menu.button.options.share": "Partager",
  "feed.menu.message.options.shareInfo": "Partagez le lien de l’événement !",
  "feed.menu.button.options.about": "À propos de la Capsule temporelle",
  "feed.menu.message.options.about": "Découvrez la Capsule temporelle !",
  "feed.createPost.title": "Nouvelle publication",
  "feed.button.creatingPost": "Publication...",
  "feed.button.createPost": "Publier",
  "feed.editImage.title": "Modifier l’image",
  "feed.newPost.selectImage": "Sélectionner une image",
  "feed.createPost.info.sendingPostImage": "Envoi de l’image...",
  "feed.createPost.info.creatingPost": "Création de la publication...",
  "feed.createPost.info.finalizingPost": "Finalisation...",
  "feed.menu.button.options.games": "Jeux",
  "feed.modalGames.title": "Jeux de la fête",
  "feed.bingo.result.line": "Ligne",
  "feed.bingo.result.column": "Colonne",
  "feed.bingo.result.fullCard": "Carton plein",
  "feed.bingo.title": "Bingo",
  "feed.bingo.description": "{guestName} a complété {challenge} du bingo",
  "feed.bingo.ctaButton": "Joue au bingo toi aussi",
  "feed.deletePost.title": "Supprimer la publication",
  "feed.deletePost.message":
    "Êtes-vous sûr de vouloir supprimer cette publication ? Cette action est irréversible.",

  "title.uploader.modalMixedEventTitle":
    "QUAND souhaitez-vous que les mariés reçoivent votre photo ou vidéo ?",
  "button.options.sendNow": "Envoyer maintenant",
  "message.options.sendNow":
    "Les mariés auront accès aux fichiers immédiatement !",
  "button.options.sendLater": "Pour le premier anniversaire de mariage",
  "message.options.sendLater":
    "Envoyer dans la capsule temporelle de l'événement !",

  "button.cancel": "Annuler",
  "button.delete": "Supprimer",
  "button.quiz.continue": "Continuer",
  "button.recorder.recorder.back": "Retour",
  "button.teamMatch.continue": "Continuer",
  "cropper.remove.frame": "Retirer le cadre",
  "cropper.use.frame": "Utiliser le cadre",
  "error.guestForm.fileTooLarge": "Le fichier doit faire au maximum 10 Mo",
  "error.guestForm.invalidFileType":
    "Veuillez sélectionner un fichier image valide",
  "error.guestForm.removePhotoFailed":
    "Échec de la suppression de la photo. Veuillez réessayer.",
  "error.guestForm.saveFailed":
    "Échec de l'enregistrement. Veuillez réessayer.",
  "error.guestForm.updateFailed":
    "Échec de l'enregistrement. Veuillez réessayer.",
  "error.guestForm.uploadFailed":
    "Échec du téléversement de la photo. Veuillez réessayer.",
  "title.guestForm.unsavedChanges": "Modifications non enregistrées",
  "message.guestForm.unsavedChanges":
    "Vous avez des modifications non enregistrées. Voulez-vous quitter sans enregistrer ?",
  "button.guestForm.cancel": "Annuler",
  "button.guestForm.exitWithoutSaving": "Quitter sans enregistrer",
  "message.bingo.remove.warning":
    "En supprimant ce défi, vos résultats seront recalculés.",
  "message.bingo.remove.warning.detail1":
    "Les lignes et colonnes affectées par la suppression seront révisées.",
  "message.bingo.remove.warning.detail2":
    "S'il y a d'autres réalisations complétées, l'heure sera mise à jour au moment actuel.",
  "message.guest.nameRequired": "Le nom est obligatoire",
  "message.quiz.progress":
    "Le quiz est toujours en cours ! Continuez et montrez ce dont vous êtes capable !",
  "message.teamMatch.progress":
    "Le jeu est toujours en cours ! Continuez et découvrez votre équipe !",
  "title.feed": "Fil de la fête",
};

export default message;
